export interface ExternalProfileLink {
  title: string
  link: string
}

export interface FormattedExternalProfileLink extends ExternalProfileLink {
  icon?: string
  mark?: string
}

function normalizeExternalUrl(link: string): string {
  return link.startsWith('http://') || link.startsWith('https://')
    ? link
    : `https://${link}`
}

export function formatExternalProfileLink(
  profile: ExternalProfileLink,
): FormattedExternalProfileLink {
  const link = normalizeExternalUrl(profile.link)
  const normalizedTitle = profile.title.toLowerCase()
  const normalizedLink = link.toLowerCase()

  if (
    normalizedTitle.includes('linkedin') ||
    normalizedLink.includes('linkedin.com')
  ) {
    return {
      ...profile,
      title: 'LinkedIn',
      link,
      icon: 'mdi-linkedin',
    }
  }

  if (
    normalizedTitle.includes('researchgate') ||
    normalizedTitle.includes('research gate') ||
    normalizedLink.includes('researchgate.net')
  ) {
    return {
      ...profile,
      title: 'ResearchGate',
      link,
      mark: 'RG',
    }
  }

  if (
    normalizedTitle.includes('sciport') ||
    normalizedTitle.includes('rlp') ||
    normalizedLink.includes('rlp-forschung.de')
  ) {
    return {
      ...profile,
      title: 'SciPort RLP',
      link,
      mark: 'SP',
    }
  }

  if (
    normalizedTitle.includes('github') ||
    normalizedLink.includes('github.com')
  ) {
    return {
      ...profile,
      link,
      icon: 'mdi-github',
    }
  }

  if (
    normalizedTitle.includes('orcid') ||
    normalizedLink.includes('orcid.org')
  ) {
    return {
      ...profile,
      link,
      icon: 'mdi-card-account-details-outline',
    }
  }

  if (
    normalizedTitle.includes('google scholar') ||
    normalizedTitle.includes('scholar') ||
    normalizedLink.includes('scholar.google')
  ) {
    return {
      ...profile,
      link,
      icon: 'mdi-google',
    }
  }

  if (normalizedTitle.includes('dblp') || normalizedLink.includes('dblp.org')) {
    return {
      ...profile,
      link,
      icon: 'mdi-book-open-page-variant-outline',
    }
  }

  if (
    normalizedTitle.includes('mastodon') ||
    normalizedLink.includes('mastodon')
  ) {
    return {
      ...profile,
      link,
      icon: 'mdi-mastodon',
    }
  }

  if (
    normalizedTitle.includes('x') ||
    normalizedTitle.includes('twitter') ||
    normalizedLink.includes('twitter.com') ||
    normalizedLink.includes('x.com')
  ) {
    return {
      ...profile,
      link,
      icon: 'mdi-twitter',
    }
  }

  if (normalizedTitle.includes('website')) {
    return {
      ...profile,
      link,
      icon: 'mdi-web',
    }
  }

  return {
    ...profile,
    link,
    icon: 'mdi-open-in-new',
  }
}

export function formatExternalProfileLinks(
  profiles: ExternalProfileLink[] = [],
): FormattedExternalProfileLink[] {
  return profiles.map(formatExternalProfileLink)
}
